import React from "react";
import { RootElementContextProvider } from "./context";
import "maplibre-gl/dist/maplibre-gl.css";

export type RootProps = {
  children: React.ReactNode;
};

export const Root = (props: RootProps) => (
  <RootElementContextProvider>{props.children}</RootElementContextProvider>
);

// Export children
export { AllFiltersButton } from "./AllFiltersButton";
export { ScrollList } from "./ScrollList";
export { Category } from "./Category";
export { Dialog } from "./Dialog";
